import React, {Component, PropTypes} from 'react'
import GetStartedWidget from './GetStartedWidget'
import { getDisplayCurrency } from 'utils/converters'
import { changeUser } from 'actions/auth'



export default class BankrollIntro extends Component {

  componentDidMount() {
    window.analytics.track('Get started', {
      index: 2
    })
  }

  onSubmit(e) {
    e.preventDefault()
    const { dispatch, userId, onComplete } = this.props
    dispatch(changeUser(userId, {
      startingBankroll: +this.refs.bankrollInput.value,
      currency: this.refs.currencyInput.value
    }))
    onComplete()
  }

  render() {
    return (
      <GetStartedWidget heading={'Let\'s set your bankroll'} content={'This is your total bankroll and includes all your money accross all your bookmakers.'}>
        <form className='form-inline'>
          <div className='form-group'>
            <select className='form-control' ref='currencyInput' defaultValue={this.props.currency} >
              { this.props.currencies.map(currency => {
                return <option value={currency} key={currency}>{ getDisplayCurrency[currency]}</option>
              })}
            </select>
          </div>
          <div className='form-group'>
            <input type='number' className='form-control'
              defaultValue={this.props.startingBankroll}
              placeholder='1000'
              min={0}
              ref='bankrollInput'
            />
          </div>
          <button type='submit' onClick={this.onSubmit.bind(this)} className='btn btn-success'>Great</button>
        </form>
      </GetStartedWidget>
    )
  }
}

BankrollIntro.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
  currencies:PropTypes.array
}



/** WEBPACK FOOTER **
 ** ./src/components/getstarted/Bankrollintro.js
 **/